import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import numeral from 'numeral';

import BlankState from '../components/BlankState';
import DataTable from '../components/DataTable';
import Page from '../components/Page';
import Modal from '../components/Modal';
// import GoodsTable from '../components/GoodsTable';
import GoodList from '../components/GoodList';
import EmailQuoteForm from '../components/EmailQuoteForm';

import LocalDB from '../utils/localDB';
import Utils from '../utils/mci-utils';
import { removeGood, editRemoveGood } from '../utils/good-utils';
import {
  intermediaryDetailView,
  getComparisonGoodsRates
} from '../utils/apiService';
import {
  getComparisonRates,
  getInsurerValue,
  calculatePremium,
  revisedPremiumCalculation
} from '../utils/calculations';
import { translations } from '../i18n/translations';
import { getCurrentUser } from '../utils/user-utils';

import { loadGoods } from '../actions/goods';

class Compare extends Component {
  constructor(props) {
    super(props);

    this.state = LocalDB.fetch('mci_form');
  }

  componentWillMount() {
    this.setState({
      quotes: [],
      selected_insurer: {},
      quotes_loading: true,
      transshipment: false,
      warehousing: false,
      selected_agency_insurers: []
    });

    console.log(this.state.selected_broker);
    console.log(this.state.selected_broker);
  }

  componentDidMount() {
    console.log(this.state);

    let { selected_goods = [] } = this.state;

    if (this.state.packaging === 'CONTAINERISED') {
      let containerized = true;
    }

    getComparisonGoodsRates(
      true,
      this.state.selected_goods[0].section,
      this.state.conveyance
    )
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });

    if (selected_goods.length > 0) {
      selected_goods.map((good, index) => {
        this.getComparisonRates(good.section_id);
        return true;
      });
    } else {
      alert('Goods are required...');
    }

    this.getSelectedAgencyInsurers();

    // Load goods from state
    this.props.loadGoods(this.state.selected_goods);
  }

  toggleAddGoods = e => {
    this.setState({
      show_goods_form: !this.state.show_goods_form
    });
  };

  handleTransshipment = e => {
    this.setState({
      transshipment: e.target.checked
    });
  };

  handleWarehousing = e => {
    this.setState({
      warehousing: e.target.checked
    });
  };

  getSelectedAgencyInsurers = () => {
    if (this.state.selected_agency.id !== '') {
      intermediaryDetailView(this.state.selected_agency.id)
        .then(response => {
          console.log(response);

          this.setState({
            selected_agency_insurers: response.data.insurer_partnerships
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  getComparisonRates(section) {
    this.setState({
      quotes_loading: true
    });

    getComparisonGoodsRates(
      this.state.packaging === 'CONTAINERISED' ? true : false,
      this.state.selected_goods[0].section,
      this.state.conveyance
    )
      .then(response => {
        console.log(response);
        let premium_rates = response.data;
        let filteredRates = null;

        if (this.state.selected_agency.id !== '') {
          filteredRates = Utils.compareTwoObjectsByInsurer(
            this.state.selected_agency_insurers,
            premium_rates
          );

          console.log(filteredRates);
          this.setState({
            quotes: filteredRates,
            quotes_loading: false
          });
          console.log(filteredRates);
        } else {
          this.setState({
            quotes: response.data,
            quotes_loading: false
          });
          console.log(response.data);
        }
      })
      .catch(error => {
        this.setState({
          quotes_loading: false
        });
      });
  }

  setSelectedInsurer = insurer => {
    this.setState({ selected_insurer: insurer }, () => {
      LocalDB.insert('mci_form', this.state);
      this.props.history.push('/buy/shipment-details');
    });
  };

  handleEmailQuote = insurer => {
    const {
      selected_goods,
      conveyance,
      packaging,
      transshipment,
      warehousing,
      currency_rate,
      other_rates,
      icc_class
    } = this.state;

    let calcPremium = revisedPremiumCalculation(
      insurer,
      selected_goods,
      conveyance,
      packaging,
      transshipment,
      warehousing,
      currency_rate.rate,
      other_rates,
      icc_class
    );

    this.setState({
      selected_insurer: insurer,
      premium: calcPremium
    });
  };

  removeGood = good => {
    const selected_goods = editRemoveGood(this.state.selected_goods, good);
    this.setState(
      {
        selected_goods
      },
      () => {
        this.props.history.push('/quote');
      }
    );
  };

  render() {
    console.log(this.state);

    let {
        other_rates,
        selected_goods,
        transshipment,
        warehousing,
        packaging,
        conveyance,
        currency_rate,
        quotes,
        quotes_loading,
        selected_insurer,
        premium,
        icc_class
      } = this.state,
      calculation = {};

    if (selected_goods.length > 0 && quotes.length > 0) {
      calculation = revisedPremiumCalculation(
        quotes[0], // Select single insurer
        selected_goods,
        conveyance,
        packaging,
        transshipment,
        warehousing,
        currency_rate.rate,
        other_rates,
        icc_class
      );
    }
    const filteredInsurers = quotes.filter((insurer, key) => {
      const premium = revisedPremiumCalculation(
        insurer,
        selected_goods,
        conveyance,
        packaging,
        transshipment,
        warehousing,
        currency_rate.rate,
        other_rates,
        icc_class
      ).premium;

      if (!isNaN(premium)) {
        return insurer;
      }
    });
    return (
      <Page pageTitle={translations.comparePrices}>
        <div className="card clearfix">
          <div className="row">
            <div className="col-sm-2">
              <div
                className="form form-horizontal"
                style={{ padding: '0 1.2em 1.2em', marginBottom: '1em' }}
              >
                <div className="form-group">
                  <h4>Options</h4>
                </div>

                <div className="form-group">
                  <div className="checkbox">
                    <label htmlFor="transshipment">
                      <input
                        type="checkbox"
                        id="transshipment"
                        name="transshipment"
                        defaultChecked={transshipment}
                        onChange={this.handleTransshipment}
                      />
                      Trans-shipment
                    </label>
                  </div>

                  <div className="checkbox">
                    <label htmlFor="warehousing">
                      <input
                        type="checkbox"
                        id="warehousing"
                        defaultChecked={warehousing}
                        name="warehousing"
                        onChange={this.handleWarehousing}
                      />
                      Warehousing
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-10">
              <GoodList
                goods={selected_goods}
                currency={currency_rate}
                removeGoodsFn={this.removeGood}
              />

              {quotes.length > 0 ? (
                <table className="table table-bordered summary-calculations">
                  <tbody>
                    <tr>
                      <td className="text-right" width="73.6%" colSpan="3">
                        Gross Direct Premium ({translations.currency})
                      </td>
                      <td className="text-right">
                        {numeral(calculation.gross_direct_premium).format(
                          '0,0.00'
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right" colSpan="3">
                        VAT ({translations.currency})
                      </td>
                      <td className="text-right">
                        {numeral(calculation.vat).format('0,0.00')}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="3" className="text-right">
                        Premium ({translations.currency})
                      </td>
                      <td className="text-right">
                        {numeral(calculation.premium).format('0,0.00')}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <BlankState
                  data={false}
                  customMessage="Calculating premiums"
                  isDataLoading={quotes_loading}
                />
              )}
            </div>
          </div>
        </div>
        <div className="card clearfix">
          {filteredInsurers.length > 0 ? (
            <DataTable
              tableId="quotes-table"
              columnTitles={['Provider', 'Premium ', 'Rate', '']}
            >
              {filteredInsurers.map((insurer, index) => {
                return insurer.insurer !== null ? (
                  <tr key={index}>
                    <td>
                      <img
                        src={insurer.insurer_logo}
                        alt={insurer.insurer_name}
                        className="img-responsive insurer-logo"
                      />
                      <span className="insurer-title">
                        {insurer.insurer_name}
                      </span>
                    </td>
                    <td>
                      <h4>
                        {translations.currency}
                        {numeral(
                          revisedPremiumCalculation(
                            insurer,
                            selected_goods,
                            conveyance,
                            packaging,
                            transshipment,
                            warehousing,
                            currency_rate.rate,
                            other_rates,
                            icc_class
                          ).premium
                        ).format('0,0') || 0}
                      </h4>
                    </td>
                    <td>
                      <h4>
                        {numeral(
                          getInsurerValue(
                            insurer,
                            conveyance,
                            packaging,
                            icc_class
                          )
                        ).value() + '%'}
                      </h4>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          this.setSelectedInsurer(insurer);
                        }}
                      >
                        <span className="glyphicon glyphicon-credit-card" />
                        &nbsp; BUY
                      </button>

                      <button
                        className="btn btn-primary btn-sm"
                        data-toggle="modal"
                        data-target=".quote-email-modal"
                        onClick={() => {
                          this.handleEmailQuote(insurer);
                        }}
                      >
                        <span className="glyphicon glyphicon-envelope" />
                        &nbsp; Email Quote
                      </button>
                    </td>
                  </tr>
                ) : null;
              })}
            </DataTable>
          ) : (
            <BlankState
              data={filteredInsurers}
              dataName="Quotes"
              isDataLoading={quotes_loading}
            />
          )}

          <Modal
            className="quote-email-modal"
            title={'Email Quote from ' + selected_insurer.insurer_name}
            closable={true}
          >
            <EmailQuoteForm insurer={selected_insurer} premium={premium} />
          </Modal>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  goods: state.goods
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ loadGoods }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Compare);



// WEBPACK FOOTER //
// ./src/pages/Compare.js